module.exports = __webpack_public_path__ + "static/media/corporate-services-img40.ef562558.jpg";